import { requestJson } from './http/apiClient';

const GET_INDEX_PINS = '/v1/accountmanager/indexpinsbaas';
const POST_GENERATE_CODE = '/v1/accountmanager/generateverificationcode';

export async function fetchWhitelist(page = 1, pageSize = 10) {
  const payload = await requestJson({
    path: GET_INDEX_PINS,
    method: 'GET',
    query: { page, pageSize },
    casing: 'title',
    includeAuth: true,
    accept: 'application/json',
    contentType: 'application/json',
  });

  const data = Array.isArray(payload?.data) ? payload.data : [];
  return {
    items: data.map(i => ({ email: i?.email ?? '-', code: i?.pinHash ?? '-' })),
    totalPages: payload?.totalPages ?? 1,
    totalItems: payload?.totalItems ?? data.length,
  };
}

export async function addWhitelistEmail(email) {
  try {
    const res = await requestJson({
      path: POST_GENERATE_CODE,
      method: 'POST',
      body: { email },
      casing: 'title',
      includeAuth: true,
      accept: 'application/json',
      contentType: 'application/json',
    });
    return { email: res?.email ?? email, code: res?.code ?? res?.pinHash ?? '-' };
  } catch (err) {
    const msg = String(err?.text || '').toLowerCase();
    if (
      err?.status === 409 ||
      msg.includes('usuário já cadastrado') ||
      msg.includes('ja cadastrado') ||
      msg.includes('duplicate')
    ) {
      const e = new Error('DUPLICATE_EMAIL');
      e.userMessage = 'E-mail já está cadastrado.';
      throw e;
    }

    const e = new Error('GENERIC_ERROR');
    e.userMessage = 'Não foi possível adicionar o e-mail.';
    e.raw = err?.text;
    throw e;
  }
}













